/**
 * Shadow Sync Entry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type ShadowSyncEntry = {
	shadowedSampleNumber: number;
	syncSampleNumber: number;
};
